import React from 'react';
import SwitchStreamerWidget from './SwitchStreamerWidget';
import StreamerRebootWidget from './StreamerRebootWidget';
import { Header, Divider, Segment } from 'semantic-ui-react';
import { CardLayout } from '../Styles';

export const Section = () => {
  return (
    <Segment basic>
      <Header as="h2">Audio Streamer</Header>
      <Divider clearing />
      <CardLayout>
        <SwitchStreamerWidget />
        <StreamerRebootWidget />
      </CardLayout>
    </Segment>
  );
};

export default Section;
